module.exports = __webpack_public_path__ + "static/media/smartserv-logo.289f68ba.png";